import * as React from 'react';
import { Link } from 'react-router-dom';
import { forms, buttons } from 'seal-ui-components';

const LoginForm = ({
    user,
    login,
    handleChange,
    errorUsernameMsg,
    errorPasswordMsg,
    isAuthenticating,
    url,
    forgot,
    isWordOnline,
    index
}) => (
    <form onSubmit={login} id="form-login" style={{ marginBottom: '0rem' }}>
        <forms.FormGrid rows={4}>
            <forms.FormGridItem row={1}>
                <forms.TextField
                    id="username"
                    label="Username"
                    onChange={event => {
                        handleChange(event);
                    }}
                    value={user.username}
                    errors={errorUsernameMsg.length !== 0 ? errorUsernameMsg : null}
                    placeholder="Enter your username or email"
                />
            </forms.FormGridItem>
            <forms.FormGridItem row={2}>
                <forms.PasswordField
                    id="password"
                    label="Password"
                    onChange={event => {
                        handleChange(event);
                    }}
                    value={user.password}
                    errors={errorPasswordMsg.length !== 0 ? errorPasswordMsg : null}
                    placeholder="Enter your password"
                />
            </forms.FormGridItem>
            <forms.FormGridItem row={3} justifySelf="end">
                <>
                    {!isWordOnline && (
                        <buttons.Button
                            forwardedAs={Link}
                            to={{ pathname: `${url}/forgot-password` }}
                            target="_blank"
                            appearance="tertiary"
                            id={`forgot_password_${index}`}
                            size="medium"
                            className="forgot-password"
                            type="button"
                        >
                            Forgot password?
                        </buttons.Button>
                    )}
                    {isWordOnline && (
                        <buttons.Button
                            id={`forgot_password_word_online_${index}`}
                            target="_blank"
                            onClick={() => {
                                forgot(url);
                            }}
                            size="medium"
                            appearance="tertiary"
                            className="forgot-password"
                            type="button"
                        >
                            Forgot password?
                        </buttons.Button>
                    )}
                </>
            </forms.FormGridItem>
            <forms.FormGridFooter row={4}>
                <forms.FormButton
                    id={`submit_login_form_${index}`}
                    disabled={isAuthenticating || user.password === '' || user.username === ''}
                    type="submit"
                    appearance="primary"
                    size="large"
                    onClick={event => {
                        login(event);
                    }}
                >
                    {isAuthenticating ? 'Logging in' : 'Login'}
                </forms.FormButton>
            </forms.FormGridFooter>
        </forms.FormGrid>
    </form>
);

export default LoginForm;
